const metaKey = (e: KeyboardEvent | React.KeyboardEvent) => {
  const isDarwin = () => {
    return /Mac|iPod|iPhone|iPad/.test(window.navigator.platform);
  };
  return isDarwin() ? e.metaKey : e.ctrlKey;
};

export default metaKey;
